import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { addtionalMemory } from "../../../Objects/Memory/Memory"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useGetAddtional } from "../../../hooks/Addtional/useGetAddtional"
import { AddtionalEntity } from "../../../Objects/Addtional/AddtionalEntity"
import { useTranslation } from "react-i18next"
import { AddtionalPupop } from "./AddtionalPupop"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const AdditionalPage: React.FC = () => {
  const { t } = useTranslation("addtional")

  const [enable, setEnable] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const { handleGetAddtional } = useGetAddtional()

  const [addtional, setAddtional] = useState<AddtionalEntity | undefined>(undefined)

  useEffect(() => {
    handleGetAddtional(() => {})
  }, [])

  const handleOpenEdite = (id: number) => {
    const entity = addtionalMemory.findById(id)!

    handleSwitchEditeOrAdd(true)

    setAddtional(entity)
  }

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setAddtional(undefined)

    setEnable(status)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  const handleCopyAddtional = () => {
    if (!addtional) {
      return
    }

    setAddtional(new AddtionalEntity({ ...addtional, id: -1, iconUrl: "" }))
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          messageCount={t("list:label_addtional_page_message_count")}
          messageEmpty={t("list:label_addtional_page_message_empty")}
          nameFindSearch={t("list:label_addtional_page_place_holder")}
          data={addtionalMemory.getListCards(true)}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleRefreshButton={() => handleGetAddtional(() => {})}
          handleOnClick={(e) => handleOpenEdite(e)}
        />
      </div>

      {enable && (
        <AddtionalPupop
          addtional={addtional}
          title={addtional && addtional.id !== -1 ? t("title_popup_edite") : t("title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
          onCopy={handleCopyAddtional}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="adicionais"
          title={t("dataImport:title", { target: t("dataImport:target_additionals") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetAddtional(() => {})}
        />
      )}
    </>
  )
}
